<mat-card class="card">
  <div class="flex justify-between items-center mb-4">
    <mat-card-title>Incident Rules</mat-card-title>
    @if (editable()) {
      <button
        class="btn-green btn-medium"
        (click)="openIncidentRuleDialog()"
        [showForClientAdmin]="true"
        avsRestrictedEl
      >
        <mat-icon>add</mat-icon>
        Add Incident Rule
      </button>
    }
  </div>

  @for (incidentRule of incidentRulesStore.entities(); track incidentRule.id) {
    <avs-incident-rule
      class="mb-4 last:mb-0"
      (delete)="deleteIncidentRule($event)"
      (edit)="openIncidentRuleDialog($event)"
      (share)="shareIncidentRule($event)"
      (toggle)="toggleIncidentRule($event)"
      [editable]="editable()"
      [incidentRule]="incidentRule"
      [measurementUnit]="incidentRule.measurementUnit"
    />
  }
</mat-card>
